"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  cs: {
    notFoundPage: {
      message: 'Položka nebo stránka se nenašla, případně na zobrazení nemáte oprávnění.'
    },
    loginPage: {
      title: 'Přihlášení k Sprinx CRM',
      username: 'Uživatelské jméno',
      password: 'Heslo',
      loginButton: 'Přihlásit'
    },
    loginErrorPage: {
      title: 'Přihlášení se nezdařilo',
      error: 'Přihlášení se nezdařilo. Uživatelské jméno nebo heslo nenalezeno.',
      pleaseRelogin: 'Zdá se, že nejste přihlášení. Prosím přihlaste se znovu.'
    },
    oauthLogin: {
      message: 'Musíte se přihlásit. Prosím zvolte jednoho z uvedených poskytovatelů.',
      loginButton: 'Přihlásit se pomocí účtu Sprinx',
      redirecting: 'Čekám na přeměrování na autentizační server...'
    },
    logout: {
      inProgress: 'Probíhá odhlášeni...',
      error: 'Chyba odhlášení',
      gotoHome: 'Přesměrovat na výchozí stránku',
      success: 'Odhlášení proběhlo úspěšně.'
    }
  }
};
var _default = messages;
exports.default = _default;